import { Student, StudentNote, StudentNoteNoteType, User } from "../../../Utilities";
import { MediaAttachmentFormValues } from "../MediaAttachment";
import { SharingRecordCustomFormValues } from "../SharingRecord";
import { StudentAcademicNoteFormValues } from "../StudentAcademicNote";
import { StudentAttendanceNoteFormValues } from "../StudentAttendanceNote";
import { StudentBehaviorNoteFormValues } from "../StudentBehaviorNote";
import { StudentHealthNoteFormValues } from "../StudentHealthNote";
import { StudentIncidentNoteFormValues } from "../StudentIncidentNote";
import { StudentInjuryNoteFormValues } from "../StudentInjuryNote";
import { StudentMedicationNoteFormValues } from "../StudentMedicationNote";
import { StudentSocialEmotionalNoteFormValues } from "../StudentSocialEmotionalNote";

export type Base = {
	noteType: StudentNote["noteType"] | null;
	body: StudentNote["body"];
	isPinned: StudentNote["isPinned"];
	requiresResolution: StudentNote["requiresResolution"];
	isResolved: StudentNote["isResolved"];
	resolvedAt: StudentNote["resolvedAt"] | null;
	resolutionDescription: StudentNote["resolutionDescription"];
	primaryStudentIDs: Student["id"][];
	secondaryStudentIDs: Student["id"][];
};

export type Create = Base & {
	mediaAttachments: MediaAttachmentFormValues.CreateInStudentNote[];
	sharingRecord: SharingRecordCustomFormValues.CreateInParent[];
	studentAcademicNote: StudentAcademicNoteFormValues.CreateInStudentNote[];
	studentAttendanceNote: StudentAttendanceNoteFormValues.CreateInStudentNote[];
	studentBehaviorNote: StudentBehaviorNoteFormValues.CreateInStudentNote[];
	studentHealthNote: StudentHealthNoteFormValues.CreateInStudentNote[];
	studentIncidentNote: StudentIncidentNoteFormValues.CreateInStudentNote[];
	studentInjuryNote: StudentInjuryNoteFormValues.CreateInStudentNote[];
	studentMedicationNote: StudentMedicationNoteFormValues.CreateInStudentNote[];
	studentSocialEmotionalNote: StudentSocialEmotionalNoteFormValues.CreateInStudentNote[];
};

export type CreateRequiredKey = Extract<keyof Create, "noteType" | "body">;

export type CreateSubset<K extends keyof Create = keyof Create> = Pick<Create, CreateRequiredKey | K>;

export const initialCreate: Create = {
	noteType: null,
	body: "",
	isPinned: false,
	requiresResolution: false,
	isResolved: false,
	resolvedAt: null,
	resolutionDescription: "",
	mediaAttachments: [],
	primaryStudentIDs: [],
	secondaryStudentIDs: [],
	sharingRecord: [SharingRecordCustomFormValues.blankItemInParent],
	studentAcademicNote: [],
	studentAttendanceNote: [],
	studentBehaviorNote: [],
	studentHealthNote: [],
	studentIncidentNote: [],
	studentInjuryNote: [],
	studentMedicationNote: [],
	studentSocialEmotionalNote: [],
};

export type Detail = Base & {
	createdAt: StudentNote["createdAt"] | null;
	authorID: User["id"] | null;
};

export type DetailSubset<K extends keyof Detail = keyof Detail> = Pick<Detail, K>;

export const noteTypeOptions = [
	{ value: StudentNoteNoteType.Academic },
	{ value: StudentNoteNoteType.Attendance },
	{ value: StudentNoteNoteType.Behavior },
	{ value: StudentNoteNoteType.General },
	{ value: StudentNoteNoteType.Health },
	{ value: StudentNoteNoteType.Incident },
	{ value: StudentNoteNoteType.Injury },
	{ value: StudentNoteNoteType.Medication },
	{ value: StudentNoteNoteType.SocialEmotional },
];
